import { Helmet } from 'react-helmet-async';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';

import { MonitorModules } from './components/MonitorModules';
import { useMonitorPage } from './hooks/useMonitorPage';
import { MONITOR_RESOURCE_MONITOR_PAGE } from './utils/monitorResourceIds';

const MONITOR_BREADCRUMBS = [{ label: 'Monitor', isActive: true }];

const MonitorPage = () => {
  const { hasSelectedDealer } = useMonitorPage();

  return (
    <>
      <Helmet>
        <title>Monitor the dealership</title>
        <meta
          name="description"
          content="Monitor dealership nurturing plan execution and related operations"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasSelectedDealer}
        breadcrumbsList={MONITOR_BREADCRUMBS}
        pageTitle="Monitor the dealership"
        contentVariant="centered"
      >
        <MonitorModules />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  MonitorPage,
  MONITOR_RESOURCE_MONITOR_PAGE,
);
